// Schedule Table
$(window).on('load', function() {
    window.initScheduleTables();
});
window.initScheduleTables = function () {
    $('.schedule__table').each(function() {
        var totalDaysInSchedule = $(this).find('tbody tr td').length;
        var daysVisible = parseInt($(this).css('z-index'));
        if (totalDaysInSchedule > daysVisible) { $(this).find('.schedule__table_paginator').show(); }
        if (totalDaysInSchedule == daysVisible) { $(this).addClass('at-the-end'); }
        $(this).find('.schedule__table_paginator .prev').unbind('click').bind('click', function(){ updateSchedule(this, -1); });
        $(this).find('.schedule__table_paginator .next').unbind('click').bind('click', function(){ updateSchedule(this, +1); });
        // find first performance in schedule:
        var firstPerformanceDayNumber = $(this).find('tbody tr td button').first().parent().index() + 1;
        if (firstPerformanceDayNumber > daysVisible) {
            // get text of date for first performance:
            var firstPerformanceDayString = $(this).find('tbody tr td button').first().parent().find('.schedule__table_date').html();
            $(this).find('.schedule__table_filmstart .filmstart')
                .attr('data-day', firstPerformanceDayNumber)
                .click(function() { updateSchedule(this, parseInt($(this).attr('data-day')), true); })
                .find('span').html(firstPerformanceDayString);
            $(this).find('.schedule__table_filmstart').show();
        }
    });
}
window.updateSchedule = function (target, changeBy, isDay) {
    var scheduleTable = $(target).parents('.schedule__table');
    var isDay = isDay || false;
    var totalDaysInSchedule = scheduleTable.find('tbody tr td').length;
    var daysVisible = parseInt(scheduleTable.css('z-index'));
    var firstPerformanceDayNumber = scheduleTable.find('.schedule__table_filmstart .filmstart').attr('data-day');

    if (totalDaysInSchedule > daysVisible) {
        var currentStart = parseInt(scheduleTable.attr('data-current')) || 1;
        var newStart = isDay ? Math.floor(changeBy / daysVisible) * daysVisible : currentStart + (changeBy * daysVisible);
        scheduleTable.removeClass('at-the-start at-the-end');
        if (newStart <= 1) {
            newStart = 1;
            scheduleTable.addClass('at-the-start');
        }

        if(firstPerformanceDayNumber && isDay) {
            if(firstPerformanceDayNumber % daysVisible == 0) {
                newStart = (firstPerformanceDayNumber - daysVisible) + 1;
            } else {
                newStart = firstPerformanceDayNumber - ((firstPerformanceDayNumber % daysVisible) - 1);
            }
        }

        if (newStart >= totalDaysInSchedule - daysVisible) {
            if((newStart + daysVisible) > totalDaysInSchedule) {
                newStart = totalDaysInSchedule - daysVisible + 1;
            }
            scheduleTable.addClass('at-the-end');
        }
        
        scheduleTable.attr('data-current', newStart);
        scheduleTable.find('tbody tr td').hide();
        for (var i = newStart; i < newStart + daysVisible; i++) {
            scheduleTable.find('tbody tr td:nth-child(' + i + ')').show();
        }
    }
    if (firstPerformanceDayNumber > daysVisible) {
        if (firstPerformanceDayNumber >= newStart && firstPerformanceDayNumber < newStart + daysVisible) {
            scheduleTable.find('.schedule__table_filmstart').hide();
        } else {
            scheduleTable.find('.schedule__table_filmstart').show();
        }
    }
}